export const DEFAULT_THEME = 'dark';

// This is the theme preference that the user has selected in the UI
export type UserThemeOption = 'system' | 'light' | 'dark';

// This is the theme that is actually applied based on user selection
export type EffectiveTheme = 'light' | 'dark';
